import i18next from 'i18next';

export const tBilling = (key, options = {}) => i18next.t(`billing:${key}`, options);

export const subscriptionStatusLabel = (status) => (
    tBilling(`subscription.status.${status}`, {defaultValue: status})
);

export const clearElement = (element) => {
    while (element?.firstChild) {
        element.removeChild(element.firstChild);
    }
};

export const appendTextElement = (parent, tagName, className, text) => {
    const element = document.createElement(tagName);
    if (className) {
        element.className = className;
    }
    element.textContent = text;
    parent.appendChild(element);
    return element;
};

export const formatInteger = (value) => new Intl.NumberFormat(
    document.documentElement.lang || undefined,
).format(Number(value) || 0);

export const formatStorageMb = (value) => {
    const megabytes = Math.max(Number(value) || 0, 0);
    if (megabytes >= 1024 && megabytes % 1024 === 0) {
        return `${formatInteger(megabytes / 1024)} GB`;
    }
    return `${formatInteger(megabytes)} MB`;
};

export const formatMoney = (amount, currency = 'EUR') => new Intl.NumberFormat(
    document.documentElement.lang || undefined,
    {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
    },
).format(Number(amount) || 0);

export const formatDate = (value) => {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return new Intl.DateTimeFormat(
        document.documentElement.lang || undefined,
        {dateStyle: 'medium'},
    ).format(date);
};

export const setBillingStatus = (container, {
    variant = 'info',
    message = '',
    persistent = false,
} = {}) => {
    if (!container) {
        return;
    }
    clearElement(container);
    container.className = `creem-billing-status creem-billing-status--${variant}`;
    container.hidden = !message;
    container.dataset.persistent = persistent ? 'true' : 'false';
    if (message) {
        appendTextElement(container, 'span', '', message);
    }
};

export const errorMessage = (error, fallbackKey = 'errors.generic') => {
    const known = {
        billing_country_unavailable: 'errors.countryUnavailable',
        catalog_product_unavailable: 'errors.productUnavailable',
        catalog_configuration_error: 'errors.configuration',
        creem_disabled: 'errors.disabled',
        checkout_in_progress: 'errors.checkoutInProgress',
        checkout_outcome_unknown: 'checkout.outcomeUnknown',
        checkout_idempotency_conflict: 'errors.idempotencyConflict',
        checkout_not_retryable: 'errors.checkoutNotRetryable',
        discount_configuration_error: 'errors.discountConfiguration',
        discount_in_progress: 'errors.discountInProgress',
        discount_outcome_unknown: 'errors.discountOutcomeUnknown',
        discount_provider_rejected: 'errors.discountProviderRejected',
        discount_not_retryable: 'errors.discountNotRetryable',
        subscription_already_exists: 'errors.subscriptionAlreadyExists',
        subscription_checkout_conflict: 'errors.subscriptionCheckoutConflict',
        checkout_provider_rejected: 'errors.providerRejected',
        subscription_change_in_progress: 'subscription.changeInProgress',
        subscription_change_pending: 'subscription.changeInProgress',
        subscription_change_outcome_unknown: 'subscription.changeOutcomeUnknown',
        subscription_change_provider_rejected: 'subscription.changeRejected',
        subscription_change_not_allowed: 'subscription.changeNotAllowed',
        subscription_change_not_retryable: 'subscription.changeNotRetryable',
        subscription_reconciliation_unavailable: 'subscription.reconcileUnavailable',
        customer_portal_unavailable: 'subscription.portalUnavailable',
        creem_subscription_managed_separately: 'errors.creemSubscriptionManagedSeparately',
    };
    return tBilling(known[error?.code] || fallbackKey);
};
